import fetchServer from "../../fetchServer";
import { PDF_API_BASE } from "./pdfApiBase";

/**
 * DELETE /api/v1/credentials/:id — delete Adobe PDF credential (admin).
 */
export default async function deletePdfCredential(id) {
  let result = {
    return: 0,
    msg: "Something went wrong deleting PDF credential",
  };

  if (!id) {
    result.msg = "Missing credential id";
    return result;
  }

  try {
    const res = await fetchServer({
      method: "DELETE",
      url: `/api/v1/credentials/${id}`,
      api: PDF_API_BASE,
    });

    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: res.data?.data ?? res.data,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.error) {
      result.msg = res.error;
    } else if (res?.data?.message) {
      result.msg = res.data.message;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
